import {
  Directive,
  HostBinding,
  HostListener,
  Input,
  Optional,
} from '@angular/core';
import { MatAnchor } from '@angular/material/button';
import { MatListItem } from '@angular/material/list';
import { AuthService } from './auth.service';
import { NeedPermissionButtonDirective } from './need-permission-button.directive';

@Directive({
  selector: 'a[atmNeedPermissionAnchor], a[need-permission]',
})
export class NeedPermissionAnchorDirective extends NeedPermissionButtonDirective {
  override get disabled(): boolean {
    return this.anchor?.disabled ?? this.listItem?.disabled ?? super.disabled;
  }
  override set disabled(disabled: boolean) {
    super.disabled = disabled;
    if (this.anchor) {
      this.anchor.disabled = disabled;
    }
    if (this.listItem) {
      this.listItem.disabled = disabled;
    }
  }

  @HostBinding('attr.tabindex')
  @Input()
  get tabIndex(): number {
    return this.disabled ? -1 : this._tabIndex || 0;
  }
  set tabIndex(tabIndex: number) {
    this._tabIndex = tabIndex;
  }
  private _tabIndex: number | undefined;

  @HostBinding('attr.disabled')
  override get attrDisabled(): true | null {
    return super.attrDisabled;
  }
  @HostBinding('attr.aria-disabled')
  override get attrAriaDisabled(): string {
    return super.attrAriaDisabled;
  }

  @HostListener('click', ['$event'])
  haltDisabledEvenu(event: Event) {
    if (this.disabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  constructor(
    auth: AuthService,
    @Optional() private anchor: MatAnchor | null,
    @Optional() private listItem: MatListItem | null
  ) {
    super(auth, null);
  }
}
